export const ReportDashboardsTags = "/engagement/report_dashboards/tags";
